import React from 'react'
import { BrowserRouter ,Route, Switch} from 'react-router-dom';
import Clima from '../pages/Clima';
import Escolares from '../pages/Escolares';
import ListaUniversidades from '../pages/ListaUniversidades';
import Main from '../pages/Main';
import MejoresCarreras from '../pages/MejoresCarreras';
import Minijuegos from '../pages/MiniJuegos';
import TestAptitud from '../pages/TestAptitud';
import NotFound from '../pages/NotFound';
import TestVocacional from '../pages/TestVocacional';
import Animaciones from '../pages/animaciones/Animaciones';
import Boton from '../pages/animaciones/Boton';
import RelojDigital from '../pages/animaciones/RelojDigital';
import RelojAnalogico from '../pages/animaciones/RelojAnalogico';
import Circulos from '../pages/animaciones/Circulos';
import Electronica from '../pages/electronica/Electronica';
import Algoritmos from '../pages/algoritmos/Algoritmos';
import Emisor from '../pages/algoritmos/Emisor';
import Receptor from '../pages/algoritmos/Receptor';
import OrdenarIP from '../pages/algoritmos/OrdenarIP';
import Multiplicador from '../pages/algoritmos/multiplicador';
import ConvertirNumeros from '../pages/algoritmos/ConvertirNumeros';
import CesarCode from '../pages/algoritmos/CesarCode';


const App = () =>(
    <BrowserRouter>
        <Switch>
            <Route exact path = "/" component = {Main}/>
            
            <Route exact path = "/clima" component = {Clima}/>
            
            <Route exact path = "/minijuegos" component = {Minijuegos}/>

            <Route exact path = "/escolares" component = {Escolares}/>
            <Route exact path = "/mejorescarreras" component = {MejoresCarreras}/>
            <Route exact path = "/test-aptitud" component = {TestAptitud}/>
            <Route exact path = "/test-vocacional" component = {TestVocacional}/>
            <Route exact path = "/lista-universidades" component = {ListaUniversidades}/>

            <Route exact path = "/animaciones" component = {Animaciones}/>
            <Route exact path = "/boton" component = {Boton}/>
            <Route exact path = "/reloj-digital" component = {RelojDigital}/>
            <Route exact path = "/reloj-analogico" component = {RelojAnalogico}/>
            <Route exact path = "/circulos" component = {Circulos}/>
            
            <Route exact path = "/electronica" component = {Electronica}/>

            <Route exact path = "/algoritmos" component = {Algoritmos}/>
            <Route exact path = "/emisor-crc" component = {Emisor}/>
            <Route exact path = "/receptor-crc" component = {Receptor}/>
            <Route exact path = "/ordenar-ips" component = {OrdenarIP}/>
            <Route exact path = "/multiplicador" component = {Multiplicador}/>
            <Route exact path = "/convertir-numeros" component = {ConvertirNumeros}/>
            <Route exact path = "/cesar-encrypt" component = {CesarCode}/>

            <Route component = {NotFound}/>
        </Switch>
        
        
        
    </BrowserRouter>
)
export default App